<template>
  <v-container v-if='loaded'
    fill-height
    fluid
    grid-list-xl>

    <v-dialog v-model="openAuditTrail" max-width="1200px">
      <app-audit-trail-timeline entity="request" v-if='openAuditTrail' :entity_id="request.id" :fields='config.fields'/>
    </v-dialog>

    <v-flex>
      <app-upsert
        :config="config"
        :item="request"
        :readonly="request.status === 'REPLIED'"
        :title="request.protocol && request.protocol.name"
        :subtitle="`${request.status} REQUEST`"
        ref='upsert'
        hide-save
        @update:valid='v => valid = v'
        @saved="saved">

        <template slot='headerActions'>

          <app-audit-trail-btn @click="openAuditTrail = true" />
          <app-patch v-if='request.id' entity="request" :entity_id="request.id" :protocol_id="request.protocol_id"/>

          <v-btn
            color="red"
            @click="$router.push('/request')">
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </template>

        <template v-slot:actions="{ item }">
          <v-btn
            v-if="['REPLIED'].includes(request.status) && request.response_pdf"
            class="mx-1"
            color="purple darken-2 white--text"
            :href='`${BASE_URL}/pdf/${request.response_pdf}`'>
            RESPONSE
              <v-icon color=''>mdi-file-pdf-box</v-icon> 
            </v-btn>

          <template v-if="request.status === 'CONFIRMED'">
            <v-chip class='mr-1' v-for='item in missingDrugs' :key='item.id' :color='item.color'> {{item.label}}</v-chip>
          </template>

          <v-btn
            v-if="request.status === 'NEW'"
            id="confirm_btn"
            :disabled="!valid || !nDrugs || loading"
            :loading='loading'
            class="mx-1 font-weight-light"
            color="primary"
            @click="confirm">Confirm</v-btn>

            <v-btn
            v-if="request.status === 'CONFIRMED'"
            id="save_btn"
            class="mx-1 font-weight-light"
            color="success"
            :loading='loading'
            :disabled='!valid || !nDrugs || loading'
            @click="send(item)">Save</v-btn>

          <app-table
            v-if="request.status === 'NEW'"
            title='Requested Drugs'
            :config="drugConfig"
            :filters="{ request_id }"
            @loaded='dataLoaded'
            no-search
            :hidden-fields="{ request_id, protocol_id: request.protocol_id, provider_id: request.provider.id }"/>
          <app-table
            v-else
            title='Response Drugs'
            :config="drugConfirmConfig"
            :filters="{ request_id }"
            @loaded='dataLoaded'
            :hide-upsert="request.status === 'REPLIED'"
            :hide-actions="request.status === 'REPLIED'"
            no-search
            :hidden-fields="{ request_id, protocol_id: request.protocol_id, provider_id: request.provider.id }" />
        </template>

      </app-upsert>


    </v-flex>

  </v-container>
</template>

<script>
const BASE_URL = process.env.VUE_APP_BASE_API
import config from './config_edit.js'
import drugConfig from './drug_index.js'
import drugConfirmConfig from './drug_confirm.js'
const { getDetail, upsert, getList } = require('@/api/base_entity')
const { confirmRequest } = require('@/api/request')

export default {
  inheritAttrs: false,
  data () {
    return {
      BASE_URL,
      valid: false,
      config,
      drugConfig,
      drugConfirmConfig,
      request_id: null,
      requestedDrugs: [],
      openDrugs: false,
      openSite: false,
      isNew: true,
      nDrugs: 0,
      request: {},
      protocol: {},
      loaded: false,
      loading: false,
      drugs: [],
      openAuditTrail: false
    }
  },
  async created () {
    this.request_id = Number(this.$route.params.requestId)
    this.request = await getDetail('request', { id: this.request_id })
    if (this.request.status === 'CONFIRMED') {
      this.requestedDrugs = await getList('request_has_drug', { request_id: this.request_id }).then(ret => ret.data)
    }
    this.loaded = true
  },
  computed: {
    missingDrugs () {
      if (this.request.status !== 'CONFIRMED') return []
      return this.requestedDrugs.map(d => {
        const n_confirmed = this.drugs.reduce((tot, item) => tot + (item.drug_id === d.drug_id ? item.n_pieces : 0), 0)
        return {
          label: `${d.drug.name} ${d.drug.packaging === 'Labels'?  d.drug.labels?.join(',') : d.drug.dose + d.drug.measure_unit} (${n_confirmed} of ${d.n_pieces})`,
          color: n_confirmed === d.n_pieces ? 'green' : 'warning',
          n_requested: n_confirmed,
          n_confirmed: d.n_pieces,
          completed: n_confirmed === d.n_pieces
        }
      })
    }
  },
  methods: {
    async dataLoaded (data) {
      this.nDrugs = data.length
      if (this.request.status === 'CONFIRMED') {
        this.drugs = data
      }
    },
    async confirm () {
      // confermo la richiesta
      this.loading = true
      try {
        await confirmRequest(this.request_id)
      } catch (e) {
        this.$root.$emit("openSnackbar", {
          message: `Error: ` + e && e.response ? e.response.data.message : e,
          color: "error"
        })
        this.loading = false
        return
      }
      this.$router.go()
    },
    async send (item) {
      if (!this.$refs.upsert.validate()) return

      // check first missing drugs
      if (this.missingDrugs.find(d => !d.completed)) {
        this.$root.$emit("openSnackbar", {
          message: `Please insert all requested drugs`,
          color: "error"
        })
        return
      }
      this.loading = true

      const formData = new FormData()
      Object.keys(item).forEach(key => {
        formData.append(key, item[key])
      })

      try {
        await upsert(`response/confirm/${item.id}`, formData)
        this.$router.go()
      } catch (e) {
        this.$root.$emit("openSnackbar", {
          message: `Error: ` + e && e.response ? e.response.data.message : e,
          color: "error"
        })
        this.loading = false
        return
      }        
    },
    saved ({ data }) {
      this.request_id = data.id
      this.request = data
      this.isNew = false
    },
  }
}
</script>
